import { Search } from "lucide-react";
import { useEffect, useState } from "react";

const texts = [
  "Welcome kits",
  "Corporate Gifts",
  "Employee Gifts",
  "Custom Hampers",
  "Eco Friendly Gifts",
];

const SearchBar = () => {
  const [placeholder, setPlaceholder] = useState("");
  const [textIndex, setTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const currentText = texts[textIndex];

    if (charIndex < currentText.length) {
      const timeout = setTimeout(() => {
        setPlaceholder(currentText.slice(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      }, 100);

      return () => clearTimeout(timeout);
    }

    const nextTimeout = setTimeout(() => {
      setCharIndex(0);
      setPlaceholder("");
      setTextIndex((prev) => (prev + 1) % texts.length);
    }, 2000);

    return () => clearTimeout(nextTimeout);
  }, [charIndex, textIndex]);

  return (
    <div className="flex items-center gap-2 border border-primary rounded-lg px-3 py-2 w-[220px] lg:w-[260px] bg-transparent">
      <Search size={18} className="text-primary flex-shrink-0" />

      <input
        type="text"
        placeholder={placeholder}
       className="w-full bg-transparent outline-none text-primary placeholder:text-primary text-[12px] tracking-wide"
      />
    </div>
  );
};

export default SearchBar;